<template>
  <section class="data-deletion-content py-5">
    <div class="container">
      <div class="row">
        <div class="col-lg-10 mx-auto">
          <IntroductionSection />
          <AccountStatusSection />
          <DataTypesSection />
          <DeletionMethodsSection />
          <RetentionSection />
          <TimelineSection />
          <ContactSection />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import IntroductionSection from '@/components/cancellazione/content/IntroductionSection.vue'
import AccountStatusSection from '@/components/cancellazione/content/AccountStatusSection.vue'
import DataTypesSection from '@/components/cancellazione/content/DataTypesSection.vue'
import DeletionMethodsSection from '@/components/cancellazione/content/DeletionMethodsSection.vue'
import RetentionSection from '@/components/cancellazione/content/RetentionSection.vue'
import TimelineSection from '@/components/cancellazione/content/TimelineSection.vue'
import ContactSection from '@/components/cancellazione/content/ContactSection.vue'

export default {
  name: 'DataDeletionContent',
  components: {
    IntroductionSection,
    AccountStatusSection,
    DataTypesSection,
    DeletionMethodsSection,
    RetentionSection,
    TimelineSection,
    ContactSection
  }
}
</script>

<style scoped>
.data-deletion-content {
  background-color: #f8f9fa;
}
</style>
